import { Get, Post, Put, Delete } from "services";
import { ApiPath } from "paths";

export const searchResourceType = async (params) => {
  const res = await Post(`${ApiPath.SEARCH_RESOURCE_TYPE}`, params);
  return res;
};

export const getResourceTypes = async ({ venueId }) => {
  const res = await Get(`${ApiPath.RESOURCE_TYPE}`, { venueId });
  return res;
};

export const getResourceType = async ({ resourceTypeId, ...body }) => {
  const res = await Get(`${ApiPath.RESOURCE_TYPE_ID(resourceTypeId)}`,body);
  return res;
};

export const createResourceType = async ({
  venueId,
  name,
  defaultCapacity,
  defaultCleanupDuration,
  shape,
  defaultReservationDuration,
  minimumSpentAmount,
}) => {
  const res = await Post(`${ApiPath.RESOURCE_TYPE}`, {
    venueId,
    name,
    defaultCapacity,
    defaultCleanupDuration,
    shape,
    defaultReservationDuration,
    minimumSpentAmount,
  });
  return res;
};

export const editResourceType = async ({resourceTypeId, ...payload}) => {
  const res = await Put(`${ApiPath.RESOURCE_TYPE_ID(resourceTypeId)}`, payload);
  return res;
};

export const deleteResourceType = async ({resourceTypeId}) => {
  const res = await Delete(`${ApiPath.RESOURCE_TYPE_ID(resourceTypeId)}`);
  return res;
};
